import { config } from '@/config/env';

interface TokenResponse {
  access_token: string;
  id_token: string;
  refresh_token?: string;
  token_type: string;
  expires_in: number;
}

interface CognitoUser {
  sub: string;
  email: string;
  nickname?: string;
  name?: string;
  picture?: string;
  email_verified?: boolean;
}

// Google OAuth URL 생성
export function getGoogleLoginUrl(): string {
  const params = new URLSearchParams({
    client_id: config.cognitoClientId,
    response_type: 'code',
    scope: 'email openid profile',
    redirect_uri: config.redirectUri,
    identity_provider: 'Google',
  });
  
  return `https://${config.cognitoDomain}/oauth2/authorize?${params.toString()}`;
}

// Authorization code를 토큰으로 교환
export async function exchangeCodeForTokens(code: string): Promise<TokenResponse> {
  const params = new URLSearchParams({
    grant_type: 'authorization_code',
    client_id: config.cognitoClientId,
    code,
    redirect_uri: config.redirectUri,
  });

  const response = await fetch(`https://${config.cognitoDomain}/oauth2/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString(),
  });

  if (!response.ok) {
    const error = await response.text();
    console.error('Token exchange error:', error);
    throw new Error('토큰 교환에 실패했습니다');
  }

  return response.json();
}

// ID 토큰에서 사용자 정보 파싱 (JWT decode)
export function parseIdToken(idToken: string): CognitoUser {
  try {
    const payload = idToken.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Token parse error:', error);
    throw new Error('토큰 파싱에 실패했습니다');
  }
}

// Refresh token으로 새 access token 획득
export async function refreshAccessToken(refreshToken: string): Promise<TokenResponse> {
  const params = new URLSearchParams({
    grant_type: 'refresh_token',
    client_id: config.cognitoClientId,
    refresh_token: refreshToken,
  });

  const response = await fetch(`https://${config.cognitoDomain}/oauth2/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString(),
  });

  if (!response.ok) {
    throw new Error('토큰 갱신에 실패했습니다');
  }

  return response.json();
}

// 로그아웃 URL
export function getLogoutUrl(): string {
  const params = new URLSearchParams({
    client_id: config.cognitoClientId,
    logout_uri: config.redirectUri,
  });
  
  return `https://${config.cognitoDomain}/logout?${params.toString()}`;
}

// 로그인 URL (getGoogleLoginUrl의 별칭)
export function getLoginUrl(): string {
  return getGoogleLoginUrl();
}
